<template>
  <ListTemplate
    :fields="fields"
    :api-url="apiURL"
    title="Services"
    default-sort="service_group.name,name"
  >
    <template #icon="props">
      <img
        v-if="props.rowData.service_icon_id"
        :src="iconURL(props.rowData.service_icon_id)"
        width="42"
        class="mr-3 bg-white rounded-pill"
      >
    </template>
    <template #colour="props">
      <span
        v-if="props.rowData.colour"
        style="width: 20px; height: 20px; display: inline-block;"
        :style="{ 'background-color': props.rowData.colour }"
      />
    </template>
  </ListTemplate>
</template>

<script>
/**
 * View to display an email template
 */
import ListTemplate from '@/components/ListTemplate'
import groupAPI from '@/api/group'

export default {
  components: {
    ListTemplate,
  },
  props: {
    groupId: {
      type: [String, Number],
      required: true,
    },
  },
  data () {
    return {
      fields: [
        {
          name: 'service_group_name',
          title: 'Group',
          dataClass: 'text-nowrap',
          // sortField: 'service_group.name',
          filterType: String,
          filterField: 'service_group.name_like',
        },
        {
          name: 'name',
          title: 'Name',
          dataClass: 'text-nowrap',
          sortField: 'name',
          filterType: String,
          filterField: 'name_like',
        },
        {
          name: 'descr',
          title: 'Description',
        },
        {
          name: 'price',
          title: 'Price',
        },
        {
          name: 'slo',
          title: 'SLO (days)',
        },
        {
          name: 'max',
          title: 'Max',
        },
        {
          name: 'icon',
          title: 'Icon',
        },
        {
          name: 'colour',
          title: 'Colour',
          dataClass: 'center aligned',
        },
        {
          name: 'is_default',
          title: 'Is Default',
          dataClass: 'center aligned',
          formatter: this.yesNo,
        },
        {
          name: 'team_name',
          title: process.env.VUE_APP_TEAM_NAME,
        },
        {
          name: 'actions',
          title: 'Actions',
          titleClass: 'center aligned',
          dataClass: 'center aligned',
        },
      ],
      error: '',
    }
  },
  computed: {
    apiURL () {
      return groupAPI.servicesURL(this.groupId)
    },
  },
  methods: {
    iconURL (id) {
      return '/api' + groupAPI.serviceIconURL(this.groupId, id)
    },
    yesNo (y) {
      return y ? 'Yes' : 'No'
    },
  },
}
</script>
